module.exports = __webpack_public_path__ + "static/media/job-finder-premium-no-bg.c986a894.svg";